angular.module('core')
  .controller('EdxReportController', [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$window',
    'authentication',
    'assignMode',
    'schoolApi',
    'classroomApi',
    'studentApi',
    'translateFilter',
    function (
      $rootScope,
      $scope,
      $state,
      $timeout,
      $window,
      authentication,
      assignMode,
      schoolApi,
      classroomApi,
      studentApi,
      translateFilter) {
        $scope.$on('$stateChangeSuccess', updateBreadcrumbs);

        function updateBreadcrumbs(){
          // $stateChangeSuccess fires during Guardian Dashboard navigation before
          // the parent component has populated $scope.state. Guard here (and in
          // each breadcrumb helper) to avoid errors when context is not yet available.
          if (!$scope.state || !$scope.state.context) {
            return;
          }

          $scope.reportBreadcrumb = null;

          switch($state.params.pane) {
            case "assignments":
              $scope.reportName = translateFilter('reports.assignmentHistory');
              addClassroomBreadcrumb();
              setTimeout(function(){
                addStudentBreadcrumb();
              }, 600);
              break;
            case "activity":
              $scope.reportName = translateFilter('reports.activityFeed');
              addClassroomBreadcrumb();
              addStudentBreadcrumb();
              break;
            case "school_customers_usage":
              $scope.reportName = translateFilter('reports.dashboardUsage');
              addDistrictBreadcrumb();
              addSchoolBreadcrumb();
              break;
            case "customers_usage":
              $scope.reportName = translateFilter('reports.dashboardUsage');
              addDistrictBreadcrumb();
              break;
            case "standards":
              $scope.reportName = translateFilter('reports.standardsReport');
              addClassroomBreadcrumb();
              addStudentBreadcrumb();
              break;
            case "overview":
              if ($state.params.studentId) {
                $scope.reportName = translateFilter('reports.studentOverview');
                addStudentBreadcrumb();
              } else {
                if (localStorage.getItem('overview')) {
                  $scope.reportName = translateFilter('reports.dreamboxProficiencyByGrade');
                } else {
                  $scope.reportName = translateFilter('reports.dashboardUsage');
                }
                addClassroomBreadcrumb();
              }
          }
        }


        function appendBreadcrumb(breadcrumbEntry) {
          if($scope.reportBreadcrumb) {
            $scope.reportBreadcrumb += ' > ' + breadcrumbEntry;
          } else {
            $scope.reportBreadcrumb = breadcrumbEntry;
          }
        }

        function addDistrictBreadcrumb() {
          appendBreadcrumb(authentication.getCustomer().district_name);
        }

        function addSchoolBreadcrumb() {
          return schoolApi.getSchool($state.params.schoolId,
            function (school) {
              appendBreadcrumb(school.name);
            }
          );
        }
      function getStorageContext() {
        try {
          var contextData = localStorage.getItem('context');
          return contextData ? JSON.parse(contextData) : {};
        } catch (e) {
          console.warn('Invalid context in localStorage:', e);
          return {};
        }
      }
      function getGroupFromContext(stateContext, storageContext) {
        var stateGroup = stateContext && (stateContext.group || stateContext.classroom);
        var storageGroup = storageContext && (storageContext.group || storageContext.classroom);
        return stateGroup || storageGroup;
      }
      function getStudentDataFromContext(stateContext, storageContext) {
        var stateGroup = stateContext && stateContext.student;
        var storageGroup = storageContext && storageContext.group && storageContext.student;
        if (stateGroup) {
          stateGroup.name = stateGroup.lastName + ', ' + stateGroup.firstName;
        }
        if (storageGroup) {
          storageGroup.name = storageGroup.lastName + ', ' + storageGroup.firstName;
        }
        return stateGroup || storageGroup;
      }

        function addClassroomBreadcrumb() {
          // Guard: see updateBreadcrumbs() for why context may be absent.
          if (!$scope.state || !$scope.state.context) {
            return;
          }

          // Pull breadcrumbs from context if available.
          var getGroupForContext = getGroupFromContext($scope.state.context, getStorageContext());
          if(getGroupForContext) {
            return appendBreadcrumb(getGroupForContext.name);
          }

          // Exit early if no classroom is set, e.g. for a parent or guardian view.
          if (!$state.params.classroomId) {
            return;
          }

          return classroomApi.getClassroom($state.params.classroomId,
            function (classroom) {
              appendBreadcrumb(classroom.name);
            }
          );
        }

        function addStudentBreadcrumb() {
          // Guard: see updateBreadcrumbs() for why context may be absent.
          if (!$scope.state || !$scope.state.context) {
            return;
          }

          // Pull breadcrumbs from context if available.
          var localStorageContext = getStorageContext();
          var getGroupForContext = getStudentDataFromContext($scope.state.context, localStorageContext);
          if (getGroupForContext) {
            // Validate the cached student matches the student currently in the URL.
            var cachedId = getGroupForContext.id;
            var urlStudentId = $state.params.studentId;
            if (!urlStudentId || String(cachedId) === String(urlStudentId)) {
              localStorage.setItem('context', JSON.stringify(localStorageContext));
              return appendBreadcrumb(getGroupForContext.name);
            }
          }

          // For some reason making request without studentID returns a student anyway.
          // Return early if no student id in state
          if (!$state.params.studentId || $state.current.name === 'guardian') {
            return;
          }
          return studentApi.getStudent($state.params.studentId,
            function (student) {
              var context = getStorageContext() || $scope.state.context;
              if (context && (!context.student || context.student.id !== student.id)) {
                context.student = {
                  firstName: student.first_name,
                  lastName: student.last_name,
                  id: student.id,
                  gradeLevel: student.grade,
                  name: student.last_name + ", " + student.first_name,
                };
                localStorage.setItem('context', JSON.stringify(context));
              }
              appendBreadcrumb(student.last_name + ", " + student.first_name);
            }
          );
        }

        $scope.assignMode = assignMode;
        $scope.isGuardianView = $state.current.name === 'guardian';


        $scope.useBts2020View = authentication.useBts2020Nav();

        var blacklist = [
          'district',
          'school',
          'classroom',
          'student'
        ];

        $scope.hideNav = authentication.useBts2020Nav() && blacklist.indexOf($state.current.name) >= 0;
        $scope.showClose = $scope.hideNav && !assignMode.isAssignMode;

        $scope.onNavToggle = function() {
            $rootScope.$broadcast('onNavToggle');
            // reflow window on menu click so highcharts knows to update size
            $timeout(function() {
                $($window).resize();
            }, 400);
        };

        $scope.state = window.history.state;

        $scope.closeReport = function() {
          if ($scope.state && $scope.state.context){
            $scope.state.context.customerId = authentication.getCustomer().id;
            localStorage.setItem('context', JSON.stringify($scope.state.context));
            localStorage.setItem('impersonate', JSON.stringify($scope.state.impersonate));
          }

          // if we got a referring page go back to that one.
          if ($scope.state && $scope.state.referringPage) {
            location.assign($scope.state.referringPage);
          } else if (localStorage.getItem('referringPage')) {
            location.assign(localStorage.getItem('referringPage'));
          } else {//... else go to default page. Used when you just copy paste a link
            location.assign(authentication.getCustomerDefaultUrl());
          }

        };
      }
  ]);
